<template>
  <div class="unitlist">
    <div  style="width: 100%">
        <el-row>
          <el-col :span='4'>
            <el-button type='primary' @click='modalVisible = true; modalType = "add"'><i class="el-icon-plus"></i> 添加厂商</el-button>
          </el-col>
          <el-col :span="10" :offset='10'>
            <el-form @submit.native.prevent label-width='100px'>
              <el-form-item label='关键字检索:'>
                <el-input v-model="cdit" placeholder='厂商名称' size='mini' style='width: 80%' @keyup.enter.native='currentPage = 1; getUnitlist()' clearable @clear='currentPage = 1; getUnitlist()'>
                  <el-button slot="append" icon="el-icon-search" @click="currentPage = 1; getUnitlist()"></el-button>
                </el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
    </div>

    <!-- 厂商列表 -->
    <div class="flex-row-between">
      <h3 width='100px'>厂商列表</h3>
      <div>当前 {{total > 0 ? (pageStart + 1) : 0}} - {{pageEnd > total ? total : pageEnd}} 项, 共 {{total}} 项</div>
    </div>
    <el-table
      :data='unitlist'
      stripe
      style='width: 100%'
      border
      header-cell-class-name='myth'
      cell-class-name='mytd'
      v-loading="loading"
    >
      <el-table-column
        type="index"
        width="100"
        :index='indexMethod'
      />
      <el-table-column prop='id' label='厂商id'/>
      <el-table-column prop='name' label='厂商名称'/>
      <!-- <el-table-column prop='contact_info' label='联系方式'/> -->
      <el-table-column label='管理员'>
        <template slot-scope="scope">
          {{scope.row.adminers.length == 1 ? (scope.row.adminers[0].name + ' - ' + scope.row.adminers[0].phone_no) : scope.row.adminers.map(a => a.name + '-' + a.phone_no).join('; ')}}
        </template>
      </el-table-column>
      <el-table-column prop='create_dt' label='开通时间'/>
      <el-table-column prop='boxes_count' label='设备数量'/>
      <el-table-column prop='accept_session_rsts_url' label='数据接收地址'/>
      <el-table-column
        label='操作'
        width='180'
      >
        <template slot-scope='scope'>
          <el-button type='primary' size='mini' @click='handleSet(scope.row)'>修改</el-button>
          <el-button @click='handleRemove(scope.row)' slot='reference' type='danger' size='mini'>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="flex-row-end" style="margin-top: 16px;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        v-if="total > pageSize"
        @current-change="onPageChange"
        :current-page.sync='currentPage'
      >
      </el-pagination>
    </div>
    

    <!-- 模态窗 -->
    <el-dialog
      :title="modalType == 'add' ? '新增厂商' : '修改厂商'"
      :visible.sync="modalVisible"
      width='600px'
      :before-close="handleClose"
    >
      <el-form @submit.native.prevent ref='unit-form' :model="form" label-width='120px' :rules="rules">
        <el-form-item label='厂商名称' prop='name'>
          <el-input v-model="form.name" placeholder='请输入厂商名称'/>
        </el-form-item>
        <el-form-item label='数据接收地址' prop='accept_session_rsts_url'>
          <el-input v-model="form.accept_session_rsts_url" placeholder='请输入数据接收地址'/>
        </el-form-item>
        <!-- <el-form-item label='联系方式'>
          <el-input v-model="form.contact_info" placeholder='请输入联系方式'/>
        </el-form-item> -->
        <el-form-item label='管理员手机号' prop='phone_no' v-if="modalType != 'set'">
          <el-input v-model="form.phone_no" placeholder='请输入管理员手机号'/>
        </el-form-item>
        <el-form-item label='管理员姓名' prop='user_name' v-if="modalType != 'set'">
          <el-input v-model="form.user_name" placeholder='请输入管理员姓名'/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleOk">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { post } from '@/utils/http'
  import { validatePhone } from '@/utils/util'

  export default {
    data() {
      return {
        unitlist: [],
        total: 0,
        pageStart: 0,
        pageEnd: 0,
        currentPage: 1,
        pageSize: 10,
        form: {},
        modalVisible: false,
        modalType: '',
        loading: false,
        rules: {
          name: [
            { required: true, message: '请输入厂商名称', trigger: 'blur' }
          ],
          accept_session_rsts_url: [
            { required: true, message: '请输入数据接收地址', trigger: 'blur' }
          ],
          phone_no: [
            { required: true, message: '请输入管理员手机号', trigger: 'blur' },
            { validator: validatePhone('管理员手机号'), trigger: 'blur' }
          ],
          user_name: [
            { required: true, message: '请输入管理员姓名', trigger: 'blur' }
          ]
        },
        cdit: ''
      }
    },
    computed: {
      ...mapState(['user_id'])
    },
    mounted() {
      this.getUnitlist()
    },
    methods: {
      async getUnitlist() {
        this.loading = true
        let data = {
          page_ix: this.currentPage,
          page_size: this.pageSize
        }
        if (this.cdit) {
          data.cdit = this.cdit
        }
        try {
          const res = await post('/unit/Index/queryUnit', data)
          this.loading = false
          if (res && res.rst == 0) {
            this.unitlist = res.data.data
            this.total = res.data.total
            this.pageStart = (res.data.current_page - 1) * this.pageSize
            this.pageEnd = this.pageStart + this.pageSize
          }
        } catch(err) {
          this.loading = false
        }
      },
      handleSet(unit) {
        this.form = { ...unit }
        this.modalVisible = true
        this.modalType = 'set'
      },
      async handleOk() {
        this.$refs['unit-form'].validate(async (valid) => {
          if (valid) {
            switch (this.modalType) {
              case 'add':
                try {
                  const res1 = await post('/unit/Index/addUnit', {
                    ...this.form,
                    no: this.form.phone_no,
                    email: `${this.form.phone_no}@take.cloud`,
                    create_user_id: this.user_id,
                    accept_session_rsts_url: this.form.accept_session_rsts_url
                  })
                  if (res1 && res1.rst == 0) {
                    this.handleClose()
                    this.getUnitlist()
                    break
                  }
                  this.$message.error(res1.msg || '添加失败')
                  break
                } catch(err) {
                  this.$message.error('添加失败')
                  break
                }
              case 'set':
                try {
                  const res2 = await post('/unit/Index/setUnit', {
                    id: this.form.id,
                    name: this.form.name,
                    contact_info: this.form.contact_info,
                    accept_session_rsts_url: this.form.accept_session_rsts_url
                  })
                  if (res2 && res2.rst == 0) {
                    this.$message.success('修改成功')
                    this.handleClose()
                    this.getUnitlist()
                    break
                  }
                  this.$message.error(res2.msg || '修改失败')
                  break
                } catch(err) {
                  this.$message.error('修改失败')
                  break
                } 
            }
          } else {
            return false;
          }
        });
      },
      handleRemove(unit) {
        this.$confirm('确定要删除厂商 ' + unit.name + ' 吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            const res = await post('/unit/Index/removeUnit', {
              id: unit.id
            })
            if (res && res.rst == 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getUnitlist()
            }
          } catch(err) {
            this.$message({
              type: 'info',
              message: '删除失败请重试'
            }); 
          }
        });
      },
      handleClose() {
        this.modalVisible = false
        setTimeout(() => {
          this.modalType = ''
          this.resetForm()
          this.form = {}
        }, 200);
      },
      onPageChange(page) {
        this.currentPage = page
        this.getUnitlist()
      },
      resetForm() {
        this.$refs['unit-form'].resetFields();
      },
      indexMethod(index) {
        return index + this.pageStart + 1;
      }
    },
    name: 'unitlist'
  }
</script>
<style lang="less" scoped>

</style>
